export default {
	in: 'Gelen',
	out: 'Giden'
}